import { canEnableSwiperLoop } from './utils';

export default () => ({
    swiper: null,
    init() {
        this.enable();
    },
    enable() {
        const breakpoints = {
            320: {
                slidesPerView: 1.25,
                spaceBetween: 9.375,
            },
            568: {
                slidesPerView: 2.25,
            },
            1024: {
                slidesPerView: 3.25,
            },
            1280: {
                slidesPerView: 4.25,
            },
        };

        this.swiper = new Swiper(this.$refs.categoriesCarousel, {
            slidesPerView: 1.5,
            spaceBetween: 12,
            pagination: false,
            direction: 'horizontal',
            loop: canEnableSwiperLoop(this.$refs.categoriesCarousel, { slidesPerView: 1.5, breakpoints }),
            navigation: {
                nextEl: this.$refs.next,
                prevEl: this.$refs.previous,
            },
            breakpoints,
            autoplay: {
                delay: 333000,
                disableOnInteraction: false,
            },
            keyboard: {
                enabled: true,
            },
        });

        this.$refs.next.addEventListener('click', () => {
            this.swiper.slideNext();
        });
        this.$refs.previous.addEventListener('click', () => {
            this.swiper.slidePrev();
        });
    },
});
